import Debug from 'debug'
import SessionRecording from './SessionRecording.js'

const debug = Debug('cbio.recordings')

export default (api) => ({

  get: async (id, query, options) => {
    debug('get()', id, query)
    return new SessionRecording(api, await api.fetch(SessionRecording.url({ id }), query, options))
  },

  destroy: async (id, query, options) => {
    debug('destroy()', id, query)
    return new SessionRecording(api, await api.destroy(SessionRecording.url({ id }), query, options))
  }

})

export { SessionRecording }
